<template>
  <div class="pageCpn">
    <div class="pageCpnTitle">
      <span>{{ title }}</span>
      <div>
        <slot name="btn"></slot>
      </div>
    </div>
    <div class="pageCpnMain" v-if="layout === 'default'">
      <slot></slot>
    </div>
    <div class="left1right1" v-if="layout === 'left1right1'">
      <div class="pageLeft" :style="{ width: leftWidth, 'margin-right': '10px' }">
        <slot name="left"></slot>
      </div>
      <div class="pageRight" style="flex:1" :style="{background: bgc, padding: p}">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="left2right1" v-if="layout === 'left2right1'">
      <div class="pageLeft" :style="{ width: leftWidth }">
        <div class="leftTop">
          <slot name="leftTop"></slot>
        </div>
        <div class="line"></div>
        <div class="leftBottom">
          <slot name="leftBottom"></slot>
        </div>
      </div>
      <div class="pageRight" style="flex:1">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'page-cpn',
  props: {
    title: {
      type: String,
      default: '标题内容',
      required: true,
    },
    layout: {
      type: String,
      default: 'default',
      validator: function(value) {
        return ['default', 'left1right1', 'left2right1'].includes(value)
      },
    },
    leftWidth: {
      type: String,
      default: '370px',
    },
    p: {
      type: Number,
      default: 10,
    },
    bgc: {
      type: String,
      default: '#fff',
    }
  },
  data() {
    return {
      breadcrumb: false,
    }
  },
}
</script>
<style lang="scss" scoped>
.pageCpn {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  .pageCpnTitle {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 48px;
    background-color: #fff;
    color: #464c5b;
    line-height: 48px;
    font-weight: 700;
    text-indent: 35px;
    margin-bottom: 10px;
    padding-right: 10px;
    font-size: 16px;
  }
  .pageCpnTitle::before {
    position: absolute;
    content: '';
    width: 5px;
    height: 18px;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
    background-color: #50b08c;
  }
  .pageCpnMain {
    flex: 1;
    background-color: #fff;
    overflow-y: scroll;
  }
}

.left1right1 {
  display: flex;
  flex: 1;
  overflow: hidden;
  .pageLeft {
    padding: 10px;
    background-color: #fff;
    overflow-y: scroll;
  }
  .pageRight {
    padding: 10px;
    background-color: #fff;
    overflow-y: scroll;
  }
}
.left2right1 {
  display: flex;
  flex: 1;
  overflow: hidden;
  .pageLeft {
    overflow-y: scroll;
    .line {
      height: 10px;
      background-color: #f0f0f0;
    }
    .leftTop {
      background-color: #fff;
      padding: 10px;
    }
    .leftBottom {
      background-color: #fff;
      padding: 10px;
    }
  }
  .pageRight {
    padding: 10px;
    background-color: #fff;
    overflow-y: scroll;
  }
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 6px rgba(0, 0, 0, 0.5);
}
</style>
